import React from 'react';
import PropTypes from 'prop-types';


const RadioField = ({ choices }) => (
  choices.map(({ label, id }) => (
    <div key={id} className="question-option">
      <i className="material-icons option-icon">
        radio_button_unchecked
      </i>
      <div>
        {
          label
        }
      </div>
    </div>
  ))
);

RadioField.propTypes = {
  choices: PropTypes.array.isRequired,
};

export { RadioField };
